const privacy = [
  {
    id: 1,
    title: "المعلومات التي نقوم بجمعها",
    text: [
      "عند استخدامك لتطبيق 'بُناة'، قد نقوم بجمع المعلومات التالية:",
      " * الشخصية: مثل الاسم، البريد الإلكتروني، رقم الهاتف، الجنس، مكان الإقامة (داخل/خارج البلاد).",
      "* معلومات الملف الشخصي التطوعي: مثل المهارات، الاهتمامات، أنواع الفرص المفضلة، السيرة الذاتية .",
      "* بيانات الاستخدام: مثل تفاعلاتك مع التطبيق، الفرص التي تقدّمت لها، الوقت الذي تقضيه في التصفح.",
      "* معلومات تقنية: مثل نوع الجهاز، نظام التشغيل، عنوان IP، بيانات الأداء والأعطال (Logs).",
    ],
  },
  {
    id: 2,
    title: "كيفية استخدام المعلومات",
    text: [
      "نستخدم البيانات التي نجمعها للأغراض التالية:",
      "تخصيص الفرص التطوعية وفقًا لاهتماماتك وموقعك.",
      "تحسين أداء التطبيق وتجربة المستخدم.",
      "التواصل معك بشأن الفرص أو التحديثات.",
      "توثيق مشاركاتك وإصدار شهادات تطوعية.",
      "لأغراض أمنية وقانونية عند الحاجة.",
    ],
  },
  {
    id: 3,
    title: "مشاركة المعلومات",
    text: [
      "نحن لا نشارك معلوماتك الشخصية مع أي طرف ثالث إلا في الحالات التالية:",
      "بموافقتك الصريحة عند التقديم على فرصة تطوعية مع جهة معينة.",
      "مع شركائنا الموثوقين لتقديم خدمات محددة تتعلق بالتطبيق (مثل خدمات الإشعارات أو التحليل).",
      "للامتثال للأنظمة والقوانين أو بأمر قضائي.",
    ],
  },
  {
    id: 4,
    title: "أمان البيانات",
    text: [
      "نستخدم تقنيات حماية متقدمة (مثل التشفير، وإجراءات المصادقة) لضمان سرية معلوماتك.",
      "كما نقوم بمراجعة دورية لإجراءات الأمان الخاصة بنا.",
    ],
  },
  {
    id: 5,
    title: "حقوق المستخدم",
    text: [
      "يحق لك:",
      "الوصول إلى بياناتك الشخصية.",
      "تعديل أو تحديث معلوماتك.",
      "طلب حذف حسابك وبياناتك من التطبيق.",
      "سحب الموافقة على استخدام بياناتك في أي وقت.",
      "يمكنك التواصل معنا عبر البريد الإلكتروني لطلب أي من هذه الحقوق.",
    ],
  },
  {
    id: 6,
    title: "ملفات تعريف الارتباط (Cookies)",
    text: [
      "قد يستخدم التطبيق ملفات تعريف الارتباط لتحسين تجربة المستخدم، وتحليل استخدام المنصة، وتقديم محتوى مخصص.",
    ],
  },
  {
    id: 7,
    title: "التعديلات على سياسة الخصوصية",
    text: [
      "قد نقوم بتحديث هذه السياسة بين حين وآخر.",
      "سيتم إعلامك بأي تغييرات جوهرية عبر التطبيق أو البريد الإلكتروني.",
    ],
  },
  {
    id: 8,
    title: "للتواصل معنا",
    text: [
      "في حال وجود أي استفسار أو طلب متعلق بسياسة الخصوصية، يرجى التواصل عبر: Bunat-contact@moad.gov.sy",
    ],
  },
];

export default privacy;